module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"summary":"Summary","allarm":"Allarm","triggerMode":"Threshold sampling"},"it":{"summary":"Riepilogo","allarm":"Allarme","triggerMode":"Trigger Mode"}}')
  delete Component.options._Ctor
}
